// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__nXXiS","box":"WorkspacesBox_box__1Aa8-","node":"WorkspacesBox_node__1LhNY"};